var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrangerCasualityTestOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 56,
    r: 25.5,
    stroke: "#272d55",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 82C73.4874 78.5856 76.2538 74.5322 78.1412 70.0711C80.0286 65.61 81 60.8286 81 56C81 51.1714 80.0286 46.39 78.1412 41.9289C76.2538 37.4678 73.4874 33.4144 70 30",
    stroke: "#272d55",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82C87.8534 78.5856 90.1168 74.5322 91.661 70.0711C93.2052 65.61 94 60.8286 94 56C94 51.1714 93.2052 46.39 91.661 41.9289C90.1168 37.4678 87.8534 33.4144 85 30",
    stroke: "#272d55",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 30,
    r: 5,
    fill: "#272d55"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 82,
    r: 5,
    fill: "#272d55"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 56,
    r: 5,
    transform: "rotate(-90 14 56)",
    fill: "#272d55"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 5,
    transform: "rotate(-90 66 56)",
    fill: "#272d55"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    transform: "rotate(-90 82 56)",
    fill: "#272d55"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 56,
    r: 5,
    transform: "rotate(-90 95 56)",
    fill: "#272d55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 55.5V44",
    stroke: "#272d55",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 56L52.5 56",
    stroke: "#272d55",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrangerCasualityTestOperationIcon);
export default __webpack_public_path__ + "static/media/GrangerCasualityTestOperationIcon.70fc04071782ef4023c371d0684594a3.svg";
export { ForwardRef as ReactComponent };